import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TransitionGroupExample from './TransitionGroupExample';
import ClientProvider from './client';
export default createDemo(import.meta.url, TransitionGroupExample, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/transitions/demos/group-example/TransitionGroupExample.tsx",
    "fileName": "TransitionGroupExample.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Button from '@mui/material/Button';\nimport Collapse from '@mui/material/Collapse';\nimport IconButton from '@mui/material/IconButton';\nimport List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemText from '@mui/material/ListItemText';\nimport DeleteIcon from '@mui/icons-material/Delete';\nimport { TransitionGroup } from 'react-transition-group';\n\nconst FRUITS = [\n  '🍏 Apple',\n  '🍌 Banana',\n  '🍍 Pineapple',\n  '🥥 Coconut',\n  '🍉 Watermelon',\n];\n\ninterface RenderItemOptions {\n  item: string;\n  handleRemoveFruit: (item: string) => void;\n}\n\nfunction renderItem({ item, handleRemoveFruit }: RenderItemOptions) {\n  return (\n    <ListItem\n      secondaryAction={\n        <IconButton\n          edge=\"end\"\n          aria-label=\"delete\"\n          title=\"Delete\"\n          onClick={() => handleRemoveFruit(item)}\n        >\n          <DeleteIcon />\n        </IconButton>\n      }\n    >\n      <ListItemText primary={item} />\n    </ListItem>\n  );\n}\n\nexport default function TransitionGroupExample() {\n  const [fruitsInBasket, setFruitsInBasket] = React.useState(FRUITS.slice(0, 3));\n\n  const handleAddFruit = () => {\n    const nextHiddenItem = FRUITS.find((i) => !fruitsInBasket.includes(i));\n    if (nextHiddenItem) {\n      setFruitsInBasket((prev) => [nextHiddenItem, ...prev]);\n    }\n  };\n\n  const handleRemoveFruit = (item: string) => {\n    setFruitsInBasket((prev) => [...prev.filter((i) => i !== item)]);\n  };\n\n  const addFruitButton = (\n    <Button\n      variant=\"contained\"\n      disabled={fruitsInBasket.length >= FRUITS.length}\n      onClick={handleAddFruit}\n    >\n      Add fruit to basket\n    </Button>\n  );\n\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      {addFruitButton}\n      <List sx={{ mt: 1 }}>\n        <TransitionGroup>\n          {fruitsInBasket.map((item) => (\n            <Collapse key={item}>{renderItem({ item, handleRemoveFruit })}</Collapse>\n          ))}\n        </TransitionGroup>\n      </List>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 79,
        "focusedLines": 8,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Button from '@mui/material/Button';\nimport Collapse from '@mui/material/Collapse';\nimport IconButton from '@mui/material/IconButton';\nimport List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemText from '@mui/material/ListItemText';\nimport DeleteIcon from '@mui/icons-material/Delete';\nimport { TransitionGroup } from 'react-transition-group';\n\nconst FRUITS = [\n  '🍏 Apple',\n  '🍌 Banana',\n  '🍍 Pineapple',\n  '🥥 Coconut',\n  '🍉 Watermelon',\n];\n\ninterface RenderItemOptions {\n  item: string;\n  handleRemoveFruit: (item: string) => void;\n}\n\nfunction renderItem({ item, handleRemoveFruit }: RenderItemOptions) {\n  return (\n    <ListItem\n      secondaryAction={\n        <IconButton\n          edge=\"end\"\n          aria-label=\"delete\"\n          title=\"Delete\"\n          onClick={() => handleRemoveFruit(item)}\n        >\n          <DeleteIcon />\n        </IconButton>\n      }\n    >\n      <ListItemText primary={item} />\n    </ListItem>\n  );\n}\n\nexport default function TransitionGroupExample() {\n  const [fruitsInBasket, setFruitsInBasket] = React.useState(FRUITS.slice(0, 3));\n\n  const handleAddFruit = () => {\n    const nextHiddenItem = FRUITS.find((i) => !fruitsInBasket.includes(i));\n    if (nextHiddenItem) {\n      setFruitsInBasket((prev) => [nextHiddenItem, ...prev]);\n    }\n  };\n\n  const handleRemoveFruit = (item: string) => {\n    setFruitsInBasket((prev) => [...prev.filter((i) => i !== item)]);\n  };\n\n  const addFruitButton = (\n    <Button\n      variant=\"contained\"\n      disabled={fruitsInBasket.length >= FRUITS.length}\n      onClick={handleAddFruit}\n    >\n      Add fruit to basket\n    </Button>\n  );\n\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      {addFruitButton}\n      <List sx={{ mt: 1 }}>\n        <TransitionGroup>\n          {fruitsInBasket.map((item) => (\n            <Collapse key={item}>{renderItem({ item, handleRemoveFruit })}</Collapse>\n          ))}\n        </TransitionGroup>\n      </List>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 69
            },
            [
              "      ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "addFruitButton"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 70
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "List"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "mt"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 71
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "TransitionGroup"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 72
            },
            [
              "          ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "fruitsInBasket"
              ],
              ".",
              [
                "span",
                "pl-en",
                "map"
              ],
              "((",
              [
                "span",
                "pl-v",
                "item"
              ],
              ") ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ("
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 73
            },
            [
              "            <",
              [
                "span",
                "pl-c1 di-jsx",
                "Collapse"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "key"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "item"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-en",
                "renderItem"
              ],
              "({ ",
              [
                "span",
                "pl-smi",
                "item"
              ],
              ", ",
              [
                "span",
                "pl-smi",
                "handleRemoveFruit"
              ],
              " })",
              [
                "span",
                "pl-pse",
                "}"
              ],
              "</",
              [
                "span",
                "pl-c1 di-jsx",
                "Collapse"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 74
            },
            [
              "          ))",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 75
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "TransitionGroup"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 76
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "List"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 79,
    "focusedLines": 8,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Button",
      "@mui/material/Collapse",
      "@mui/material/IconButton",
      "@mui/material/List",
      "@mui/material/ListItem",
      "@mui/material/ListItemText",
      "@mui/icons-material/Delete",
      "react-transition-group"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
